module.exports = __webpack_public_path__ + "static/media/agenda2026.a8533f52.jpg";